// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"fa0bab45","551":"a05ee719","828":"ca0d5c80","851":"67dcc0ee"}[chunkId] + ".chunk.js";
};